import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
import axios from 'axios';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    },
    componentForm2: function componentForm2() {
      return import('./form2');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null, this.p('sync') ? h("d2-bar-cell", [this.syncButton()]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), h("component-form-2", {
      "ref": "form2",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'BOX_ALL',
        delete: 'BOX_DELETE',
        sync: 'BOX_SYNC',
        clear: 'BOX_CLEAR'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: 'box:detail',
        remove: '',
        sync: ''
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '100px'
      }, // { prop: 'box_uid', label: 'box_uid', minWidth: '100px' },
      // { prop: 'market_id', label: 'market_id', minWidth: '100px' },
      // { prop: 'device_uid', label: 'device_uid', minWidth: '100px' },
      {
        prop: 'device_number',
        label: this.$t('device_number'),
        minWidth: '100px'
      }, {
        prop: 'box_lock_address',
        label: this.$t('box_lock_address'),
        minWidth: '100px'
      }, {
        prop: 'box_name',
        label: this.$t('box_name'),
        minWidth: '100px'
      }, {
        prop: 'box_use_status',
        label: this.$t('box_use_status'),
        minWidth: '100px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "box_use_status",
              "value": row.box_use_status
            }
          });
        }
      }, {
        prop: 'box_health',
        label: this.$t('box_health'),
        minWidth: '100px',
        render: function render(_ref2) {
          var row = _ref2.row;
          return h("d2-dict", {
            "attrs": {
              "name": "box_health",
              "value": row.box_health
            }
          });
        }
      }, {
        prop: 'box_status',
        label: this.$t('box_status'),
        minWidth: '100px',
        render: function render(_ref3) {
          var row = _ref3.row;
          return h("d2-dict", {
            "attrs": {
              "name": "box_status",
              "value": row.box_status
            }
          });
        }
      }, {
        prop: 'box_aspect_type',
        label: this.$t('box_aspect_type'),
        minWidth: '100px',
        render: function render(_ref4) {
          var row = _ref4.row;
          return row.market_id == "17" || row.market_id == "12" ? h("d2-dict", {
            "attrs": {
              "name": "box_aspect_type_two",
              "value": row.box_aspect_type
            }
          }) : h("d2-dict", {
            "attrs": {
              "name": "box_aspect_type",
              "value": row.box_aspect_type
            }
          });
        }
      }, // { prop: 'box_group_uid', label: 'box_group_uid', minWidth: '100px' },
      // { prop: 'box_info_xml', label: 'box_info_xml', minWidth: '100px' },
      // { prop: 'order_number', label: 'order_number', minWidth: '100px' },
      // { prop: 'save_mobile', label: 'save_mobile', minWidth: '100px' },
      // { prop: 'get_mobile', label: 'get_mobile', minWidth: '100px' },
      // { prop: 'save_time', label: 'save_time', minWidth: '100px', formatter: row => utils.time.format1(row.save_time, 'YYYY/M/D HH:mm:ss') },
      // { prop: 'get_time', label: 'get_time', minWidth: '100px', formatter: row => utils.time.format1(row.get_time, 'YYYY/M/D HH:mm:ss') },
      // { prop: 'pick_code', label: 'pick_code', minWidth: '120px' },
      // { prop: 'record_id', label: 'record_id', width: '120px' },
      // { prop: 'send_sms_key', label: 'send_sms_key', width: '200px' },
      // { prop: 'send_msg_status', label: 'send_msg_status', minWidth: '100px' },
      // { prop: 'get_type', label: 'get_type', minWidth: '100px', render: ({ row }) => <d2-dict name="express_get_type" value={ row.get_type }/> },
      {
        prop: 'uptime',
        label: this.$t('uptime'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'ctime',
        label: this.$t('ctime'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      } // { prop: 'used_count', label: 'used_count', minWidth: '100px' },
      // { prop: 'used_month_count', label: 'used_month_count', minWidth: '100px' },
      // { prop: 'used_year_count', label: 'used_year_count', minWidth: '100px' },
      // { prop: 'used_sy', label: 'used_sy', minWidth: '100px' },
      // { prop: 'used_month_sy', label: 'used_month_sy', minWidth: '100px' },
      // { prop: 'used_year_sy', label: 'used_year_sy', minWidth: '100px' },
      // { prop: 'used_save_sy', label: 'used_save_sy', minWidth: '100px' },
      // { prop: 'used_month_save_sy', label: 'used_month_save_sy', minWidth: '100px' },
      // { prop: 'used_year_save_sy', label: 'used_year_save_sy', minWidth: '100px' },
      // { prop: 'used_get_sy', label: 'used_get_sy', minWidth: '100px' },
      // { prop: 'used_month_get_sy', label: 'used_month_get_sy', minWidth: '100px' },
      // { prop: 'used_year_get_sy', label: 'used_year_get_sy', minWidth: '100px' }
      ].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref5) {
        var row = _ref5.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('detail', [{
          icon: 'el-icon-box',
          label: _this2.$t('detail'),
          action: function action() {
            return _this2.detail(row.id, 'form2');
          }
        }], [])), _toConsumableArray(_this2.p('detail', [{
          icon: 'el-icon-collection',
          label: _this2.$t('open box'),
          type: 'danger',
          confirm: _this2.$t('confirm_open_box'),
          action: function action() {
            return _this2.sync({
              'id': row.id,
              'optype': 'open'
            });
          }
        }], [])), _toConsumableArray(_this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: _this2.$t('confirm_delete_info'),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('clear', [{
          icon: 'el-icon-delete-solid',
          label: _this2.$t('clear box'),
          type: 'danger',
          confirm: _this2.$t('confirm_clear_box'),
          action: function action() {
            return _this2.clear(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'device_number',
        label: this.$t('device_number'),
        default: this.device_number,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this3.search.form.model.device_number,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "device_number", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.start_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.end_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    device_number: function device_number() {
      return this.$route.query.device_number;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    sync1: function sync1() {
      // alert(0)
      this.sync({
        'device_number': this.$route.query.device_number,
        'optype': 'all'
      });
    },
    syncconfirm: function syncconfirm(confirm, callback) {
      this.$confirm(confirm, 'info', {
        confirmButtonText: 'submit',
        cancelButtonText: 'cancel'
      }).then(callback).catch(function () {});
    },
    syncButton: function syncButton() {
      var _this4 = this;

      var h = this.$createElement;
      var node = h("d2-button", {
        "attrs": {
          "type": "danger",
          "icon": "el-icon-upload2",
          "label": this.$t('sync box')
        },
        "on": {
          "click": function click() {
            return _this4.syncconfirm('confirm sync box', _this4.sync1);
          }
        }
      });
      return node;
    }
  })
};